import React, { useState, useEffect } from 'react';

const WhatsAppServices = ({ servicesData, isVisible: initialVisible = false }) => {
  const [isVisible, setIsVisible] = useState(initialVisible);

  useEffect(() => {
    // Trigger animation when component mounts
    setIsVisible(true);
  }, []);

  return (
    <div className="bg-[#075E54] min-h-screen w-full flex items-center justify-center py-12 px-4">
      <div className="max-w-6xl w-full">
        <div className="flex flex-col justify-center items-center text-center px-6 py-4">
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold leading-tight max-w-5xl text-white">
            Meet Clients Where They Are—On WhatsApp
          </h1>
          <div className="w-16 h-1 bg-white my-4 rounded-full"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {servicesData.map((service, index) => (
            <div 
              key={service.id || index} // Use unique id if available, otherwise fall back to index
              className={`bg-white rounded-lg p-6 shadow-lg transition-all duration-500 transform hover:shadow-xl hover:-translate-y-1 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="mb-4">{service.icon}</div>
              <h3 className="text-xl font-bold mb-2">{service.title}</h3>
              <p className="text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


export default WhatsAppServices;